<div class="content h-full">
  <markdown [data]="descriptionMd()" (click)="onMarkdownLinkClick($event)"></markdown>
</div>
 <!-- <div>{{ doc()?.descriptionMd }}</div>

  <div>{{ name() }}</div> -->
